module.exports = __webpack_public_path__ + "img/one-time-offer-40.6acc2048.png";